<template>
    <div
        class="fixed left-0 top-0 z-[2000] flex h-full w-full items-center justify-end overflow-hidden"
        :class="customClass">
        <div class="absolute left-0 top-0 h-full w-full bg-black bg-opacity-50"></div>
        <div ref="suggestionRef"
             class="z-10 h-full bg-white" :style="{'width': width}">
            <div class="bg-grey-20 px-2 py-2 flex items-center">
                <button class="th-btn th-btn-text th-btn-sm text-sm" @click="close">
                    {{ closeButtonText || t('rightAside.close') }}
                    <CloseRightAsideIcon />
                </button>
            </div>
            <div class="flex flex-col" style="height: calc(100vh - 44px);"
            >
                <slot/>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import CloseRightAsideIcon from './CloseIcon.vue';
import { onClickOutside } from '@vueuse/core';
import { cn, tw, en, jp } from './locales';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({
    messages: {
        cn, en, jp, tw,
    },
});

const props = withDefaults(defineProps<{
    onClose?: () => void;
    onOpen?: () => void;
    closeButtonText?: string;
    customClass?: string;
    closeOnClickModal?: boolean;
    width?: string;
}>(), {
    closeOnClickModal: true,
    width: '800px',
})

const emits = defineEmits<{
    (e: 'onClose'): void,
    (e: 'onOpen'): void
}>()

const PATSNAP_BIZ_TOAST_CLASS = '.patsnap-biz-toast'

function close() {
    emits('onClose')
}

const suggestionRef = ref(null)
onClickOutside(
    suggestionRef,
    (e) => {
        // @ts-ignore
        const isToast = e?.target?.closest(PATSNAP_BIZ_TOAST_CLASS)
        props.closeOnClickModal && !isToast && close();
    }
)

onMounted(() => {
    emits('onOpen')
})
</script>
